module.exports = __webpack_public_path__ + "img/logo-dwd.e9b7b73a.png";